namespace nscs.screen.stories {

    export class AnimationRunningCharacters_5 extends Phaser.GameObjects.Container {

        frame = {name:'AnimationRunningCharacters_5'};

        _bg:Phaser.GameObjects.Image;
        ground0_1:Phaser.GameObjects.Image;
        ground0_2:Phaser.GameObjects.Image;
        _nuget:Phaser.GameObjects.Sprite;
        _chick:Phaser.GameObjects.Sprite;

        constructor(scene:Phaser.Scene) {
            super(scene);


            this._bg = this.scene.add.image(-500, -200, 'bg-atlas', 'bg4' + '0000');
            this._bg.setOrigin(0, 0);
            this._bg.setScale(1.6);

            this.ground0_1 = this.scene.add.image(game.scale.width/2, 325, 'stories', 'ground2' + '0000');
            this.ground0_1.setOrigin(0.5, 1);
            this.ground0_2 = this.scene.add.image(this.ground0_1.x + this.ground0_1.width, this.ground0_1.y, 'stories', 'ground2' + '0000');
            this.ground0_2.setOrigin(0.5, 1);

            this._nuget = this.scene.add.sprite(-350, 300, 'stories', '_nuget' + '0000');
            this._nuget.setOrigin(0.5, 1);

            this._chick = this.scene.add.sprite(-200, 302, 'stories', '_chick' + '0000');
            this._chick.setOrigin(0.5, 1);

            this.add([this._bg, this.ground0_1, this.ground0_2, this._chick, this._nuget]);

            this.scene.tweens.add({
                targets: this._bg,
                duration: 6000,
                x: this._bg.x-150,
                ease: Phaser.Math.Easing.Cubic.Out
            });

            this.scene.tweens.add({
                targets: this.ground0_1,
                duration: 6000,
                x: this.ground0_1.x - 200,
                ease: Phaser.Math.Easing.Cubic.Out
            });

            this.scene.tweens.add({
                targets: this.ground0_2,
                duration: 6000,
                x: this.ground0_2.x - 200,
                ease: Phaser.Math.Easing.Cubic.Out
            });

            this.scene.tweens.add({
                targets: this._nuget,
                duration: 4000,
                x: this._nuget.x + 875,
            });
            this.scene.tweens.add({
                targets: this._chick,
                duration: 4000,
                x: this._chick.x + 825,
                delay: 150
            });

            let anim:string = nscs.gameplay.Factory.createAnimName('_nuget', 'walking');
            if (!this.scene.anims.exists(anim)) {
                this.scene.anims.create({
                    key: anim,
                    frames: this.scene.anims.generateFrameNames(this._nuget.texture.key, {
                        start: 0, end: 30, zeroPad: 4,
                        prefix: '_nuget', suffix: ''
                    }),
                    repeat: -1,
                    frameRate: 60
                });
            }
            util.Functions.delayedCall(150, ()=>{
                this._nuget.play(anim);
            });
            let _anim = nscs.gameplay.Factory.createAnimName('_chick', 'walking');
            if (!this.scene.anims.exists(_anim)) {
                this.scene.anims.create({
                    key: _anim,
                    frames: this.scene.anims.generateFrameNames(this._chick.texture.key, {
                        start: 0, end: 30, zeroPad: 4,
                        prefix: '_chick', suffix: ''
                    }),
                    repeat: -1,
                    frameRate: 60
                });
            }
            this._chick.play(_anim);

            util.Functions.delayedCall(4500, ()=>{
                this.showSecondPart();
            });

        }

        public showSecondPart():void {
            AnimationRunningCharacters_5.showAngryMan(250, 325, this, 1);
            AnimationRunningCharacters_2.showDust(300, 450, this, 1);
        }

        public static showAngryMan(x:number, y:number, parent, ind):Phaser.GameObjects.Container {
            let cnt = new Phaser.GameObjects.Container(parent.scene);
            cnt.setPosition(x, y);

            let man = new Phaser.GameObjects.Image(parent.scene, -10, 50, 'stories', 'man' + '0000');
            cnt.add(man);
            man.scaleX = -1;
            parent.scene.tweens.add({
                targets: man,
                duration: 1000,
                y: -75,
                delay: 1000
            });

            let hand = new Phaser.GameObjects.Image(parent.scene, 25, 50, 'stories', 'hand' + '0000');
            cnt.add(hand);
            parent.scene.tweens.add({
                targets: hand,
                duration: 1200,
                y: -100,
                delay: 1000
            });

            let hand_ = new Phaser.GameObjects.Image(parent.scene, 33, -125+150, 'stories', 'hand_' + '0000');
            cnt.add(hand_);
            parent.scene.tweens.add({
                targets: hand_,
                duration: 1200,
                y: -125,
                delay: 1000
            });
            
            let mask_ = new Phaser.GameObjects.Image(parent.scene, 25, 50, 'stories', 'mask_' + '0000');
            cnt.add(mask_);
            mask_.scaleX = 0.1;
            mask_.originX = 1;
            parent.scene.tweens.add({
                targets: mask_,
                duration: 1200,
                angle: 10,
                y: -100,
                delay: 1000
            });

            parent.scene.tweens.add({
                targets: hand,
                duration: 350,
                angle: -10,
                delay: 2000,
                onComplete: ()=>{
                    parent.scene.tweens.add({
                        targets: mask_,
                        duration: 500,
                        scaleX: 1,
                        angle: 5,
                        x: -15,
                        y: -120,
                        onComplete: ()=>{
                            parent.scene.tweens.add({
                                targets: mask_,
                                duration: 200,
                                y: mask_.y+5,
                                yoyo:true,
                                repeat:2,
                                delay: 1000,
                                onComplete: ()=>{
                                    parent.scene.tweens.add({
                                        targets: man,
                                        duration: 1000,
                                        y: man.y + 95,
                                        delay: 1000
                                    });
                                    parent.scene.tweens.add({
                                        targets: hand_,
                                        duration: 800,
                                        y: hand_.y + 95,
                                        delay: 1000
                                    });
                                    parent.scene.tweens.add({
                                        targets: hand,
                                        duration: 800,
                                        y: hand.y + 95,
                                        delay: 1000
                                    });
                                    parent.scene.tweens.add({
                                        targets: mask_,
                                        duration: 1000,
                                        y: mask_.y + 95,
                                        delay: 1000
                                    });
                                }
                            });
                        }
                    });
                }
            });

            let obj_ = new Phaser.GameObjects.Image(parent.scene, 2, 0, 'stories', 'obj_' + '0000');
            cnt.add(obj_);
            parent.scene.tweens.add({
                targets: obj_,
                duration: 1000,
                y: -50,
                delay: 0
            });

            parent.addAt(cnt, ind);

            return cnt;
        }
    }
}